/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Status_LowInputs */

const vi_warehouse_sales_status_low = /** @type {(inputs: Warehouse_Sales_Status_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp hết`)
};

/**

* @param {Warehouse_Sales_Status_LowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_status_low = /** @type {((inputs?: Warehouse_Sales_Status_LowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Status_LowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_status_low(inputs)
});